import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";

import { getSettings, updateSettings } from "../../../../../services/settingsServices";
import { getAllGalleries } from "../../../../../services/gallerieServices";

import {
  extractArray,
  extractSettings,
  getSettingsStats,
  isDemoMode,
  normalizeSettings,
} from "../utils/settingsManagerUtils";

export default function useSettingsManager() {
  const [settings, setSettings] = useState(normalizeSettings());
  const [galleries, setGalleries] = useState([]);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const demoMode = useMemo(() => isDemoMode(), []);

  const stats = useMemo(() => getSettingsStats(settings), [settings]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const [settingsData, galleriesData] = await Promise.all([
        getSettings(),
        getAllGalleries(),
      ]);

      setSettings(normalizeSettings(extractSettings(settingsData)));
      setGalleries(extractArray(galleriesData));
    } catch (error) {
      console.error("Erreur lors de la récupération des paramètres :", error);
      toast.error("Erreur lors du chargement des paramètres.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setSettings((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const updateField = (name, value) => {
    setSettings((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event?.preventDefault?.();

    if (demoMode) {
      toast.info("Fonction désactivée en mode Démonstration.");
      return;
    }

    try {
      setSaving(true);

      await updateSettings(settings);

      toast.success("Paramètres mis à jour avec succès.");
    } catch (error) {
      console.error("Erreur lors de la mise à jour des paramètres :", error);
      toast.error("Erreur lors de la mise à jour des paramètres.");
    } finally {
      setSaving(false);
    }
  };

  return {
    settings,
    galleries,
    loading,
    saving,
    demoMode,
    stats,

    handleChange,
    updateField,
    handleSubmit,
    refreshData: fetchData,
  };
}